import { Box, IconButton } from '@chakra-ui/core';
import React, { useCallback, useMemo } from 'react';
import { IoChevronDownOutline } from 'react-icons/io5';
import { QuestionnaireTemplateStore } from '../../../store/questionnaireTemplateModel';

const PERSPECTIVE_STYLE = { perspective: '1000px' } as const;
const ICON_BUTTON_STATIC_PROPS = {
  'aria-label': 'Expand element',
  size: 'sm',
  variant: 'ghost',
  cursor: 'pointer',
} as const;

const getIconStyles = (isExpanded: boolean) =>
  ({
    transition: 'transform 0.2s',
    transformStyle: 'preserve-3d',
    transform: isExpanded ? 'unset' : 'rotateX(180deg)',
  } as const);

export const QuestionExpandleButton = React.memo(function QuestionExpandleButton({ id }: { id: string }) {
  const isExpanded = QuestionnaireTemplateStore.useStoreState((state) => state.getElementValue(id, 'expanded'));
  const updateValue = QuestionnaireTemplateStore.useStoreActions((actions) => actions.updateElementValue);

  const handleToggle = useCallback(() => {
    updateValue({ id, path: 'expanded', value: !isExpanded });
  }, [id, isExpanded, updateValue]);

  const iconStyles = useMemo(() => getIconStyles(!!isExpanded), [isExpanded]);

  return (
    <Box sx={PERSPECTIVE_STYLE}>
      <IconButton
        tabIndex={-1}
        icon={<IoChevronDownOutline fontSize={16} />}
        {...ICON_BUTTON_STATIC_PROPS}
        sx={iconStyles}
        onClick={handleToggle}
      />
    </Box>
  );
});
